import { useEffect, useState } from "react";
import { getFlaggedReason } from "../Utilities/EventFlagging.js";

export const useIsFlagged = (currentState, events) => {
  const [isFlagged, setIsFlagged] = useState(false);
  const [flaggedReason, setFlaggedReason] = useState(null);

  useEffect(() => {
    let flagged = events.find((el) => el.flagged === true);
    if (typeof flagged !== "undefined") {
      setIsFlagged(true);
      setFlaggedReason(getFlaggedReason(currentState, flagged.eventId));
    } else {
      setIsFlagged(false);
      setFlaggedReason(null);
    }
    // eslint-disable-next-line
  }, [currentState, JSON.stringify(events)]);

  return [isFlagged, flaggedReason];
};
